import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditCostRequest(
  state: State,
  { cost }: Boundaries["editCost"]["request"],
): State {
  const index = state.findIndex((req) => req.cost.uuid === cost.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { cost, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { cost, request: setRequestStateToPending() }];
}

function handleEditCostSuccess(
  state: State,
  { cost }: Boundaries["editCost"]["success"],
): State {
  const index = state.findIndex((req) => req.cost.uuid === cost.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { cost, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { cost, request: setRequestStateToSuccess() }];
}

function handleEditCostFailure(
  state: State,
  { cost }: Boundaries["editCost"]["request"],
): State {
  const index = state.findIndex((req) => req.cost.uuid === cost.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], cost, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { cost, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editCostRequested]: handleEditCostRequest,
    [events.editCostSucceeded]: handleEditCostSuccess,
    [events.editCostFailed]: handleEditCostFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
